import { alpha, Theme } from '@mui/material';

export default {
    expandBtnHolder: {
        position: 'absolute',
        top: -1,
        left: -1,
        zIndex: 1,
        backgroundColor: 'background.default',
        flexShrink: 0,
        border: '1px solid',
        borderColor: 'primary.main',
        color: 'primary.main',
        fontSize: '16px',
        borderBottomRightRadius: '4px',
    },
    expandBtn: {
        minWidth: '24px',
        height: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
            cursor: 'pointer',
        },
    },
    openedContainer: {
        backgroundColor: 'background.default',
        borderRight: '1px solid',
        borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
        flexShrink: 0,
    },
    listHolder: {
        width: '232px',
    },
    itemListHeader: {
        justifyContent: 'space-between',
        alignItems: 'center',
        fontWeight: 'bold',
        px: 2,
        py: 1,
        mb: 1,
        borderBottom: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.16)}`,
    },
    collapseIcon: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '28px',
        height: '28px',
        borderRadius: '3px',
        fontSize: '16px',
        backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
        color: 'primary.main',
        '&:hover': {
            opacity: 0.75,
            cursor: 'pointer',
        },
    },
    list: {
        px: 2,
        pb: 1,
    },
    itemList: {
        py: '6px',
        px: 1,
        color: 'text.primary',
        borderRadius: '3px',
        '&.active': {
            color: 'primary.main',
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
        },
        '&:not(.active):hover': {
            color: 'primary.main',
            cursor: 'pointer',
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.04),
        },
    },
};
